export default __webpack_public_path__ + "static/media/a017-market-7.a33d85d6.svg";